import React from 'react';
import {
  Badge, Button, EmptyState, Table,
} from '@opendate-app/setlist';

const STATUS_COLORS = {
  active: 'success',
  trialing: 'brand',
  past_due: 'error',
  canceled: 'gray',
  paused: 'warning',
  unpaid: 'error',
  incomplete: 'gray',
  incomplete_expired: 'gray',
};

function StatusBadge({ status }) {
  return (
    <Badge color={STATUS_COLORS[status] || STATUS_COLORS.incomplete} dot>
      <span className="text-capitalize">{(status || '').replace('_', ' ')}</span>
    </Badge>
  );
}

export default function MembershipsTab({ team, memberships, loading, error }) {
  return (
    <div className="cdp-events-tab py-4">
      <div className="card">
        <div className="card-body p-0">
          <div className="border-bottom px-4 py-3 d-flex justify-content-between align-items-center">
            <h2 className="h6 mb-0">Memberships</h2>
          </div>

          <Table
            columns={[
              { key: 'name', header: 'Membership', primary: true, render: (m) => (m.product_href ? <Button as="a" href={m.product_href} variant="link-color">{m.name}</Button> : m.name) },
              {
                key: 'paid_by',
                header: 'Paid by',
                render: (m) => (m.paid_by ? (
                  <>
                    {m.paid_by.deleted ? 'Deleted contact' : (
                      <Button as="a" href={`/teams/${team.id}/crm/fans/${m.paid_by.id}`} variant="link-color">
                        {m.paid_by.name || '(No name)'}
                      </Button>
                    )}
                    <span className="text-muted">{' (household)'}</span>
                  </>
                ) : '—'),
              },
              { key: 'status', header: 'Status', render: (m) => <StatusBadge status={m.status} /> },
              { key: 'amount', header: 'Price', render: (m) => m.amount },
              {
                key: 'interval',
                header: 'Billing',
                render: (m) => <span className="text-capitalize">{m.interval || '—'}</span>,
              },
              { key: 'current_period_start', header: 'Start Date', render: (m) => m.current_period_start || '—' },
              { key: 'current_period_end', header: 'End Date', render: (m) => m.current_period_end || '—' },
              { key: 'created_at', header: 'Joined', render: (m) => m.created_at || '—' },
            ]}
            data={memberships}
            getRowKey={(m) => m.id}
            loading={loading}
            error={error || null}
            empty={<EmptyState size="sm" title="No memberships found." />}
          />
        </div>
      </div>
    </div>
  );
}
